/**
 * Song Requests Module - Frontend
 * 
 * Exports the frontend components for the Song Requests module:
 * - DashboardWidget: the read-only glance (now playing, queue length, next)
 * - SettingsPage: the channel's settings and bans
 * - ChannelPanel: the queue's actions, on the channel page below the chat (R25 chat 2)
 */

import { Music } from 'lucide-react'
import type { FrontendModule } from '../types'

import { SongRequestsWidget } from './DashboardWidget'
import { SongRequestsSettings } from './SettingsPage'
import { SongRequestsQueuePanel } from './QueuePanel'

/**
 * Song Requests module definition.
 */
export const songRequestsModule: FrontendModule = {
  name: 'song_requests',
  displayName: 'Song Requests',
  DashboardWidget: SongRequestsWidget,
  SettingsPage: SongRequestsSettings,
  ChannelPanel: SongRequestsQueuePanel,
  icon: Music,
}

// Re-export components for direct imports
export { SongRequestsWidget, SongRequestsSettings, SongRequestsQueuePanel }

// Picked up by the registry's build-time glob (modules/index.ts, R23).
export default songRequestsModule
